const isEmptyEditableElement = (element) => !element.innerText || element.innerText === '\n';

export default isEmptyEditableElement;
